import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ComparisonTable from "../../../components/ComparisonTable/ComparisonTable";

export default function MwaliJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Mwali (Mohéli, Comoros) Jurisdiction"
                subtitle="An Established Offshore Licensing Hub in the Indian Ocean"
                description="Mwali (Mohéli), part of the Union of Comoros, has become a respected offshore financial services jurisdiction. Through the Mwali International Services Authority (MISA), it offers a wide range of licenses — including banking, brokerage, gaming, crypto, and insurance — combining cost-effectiveness with credibility and global recognition."
                badges={[
                    "Banking",
                    "Brokerage",
                    "Gaming",
                    "Crypto",
                    "Insurance & Trust"
                ]}
                buttonText="Request a Mwali Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/mwali-jurisdiction.png')}
                imageAlt="Mwali Mohéli Comoros Offshore Jurisdiction"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Mwali?"
                        blocks={[
                            {
                                items: [
                                    { text: "Recognized Authority — regulated by MISA, not a new/untested framework." },
                                    { text: "International Reputation — licenses accepted by PSPs and partners globally." },
                                    { text: "Wide Range of Licenses — banking, brokerage, gaming, insurance, crypto." },
                                    { text: "Compliance-Based — AML/KYC frameworks aligned with FATF standards." },
                                    { text: "Banking & PSP Access — better acceptance rates than many newer offshore jurisdictions." },
                                    { text: "Affordable Fees — competitive setup and renewals compared to Malta, Cyprus, or Isle of Man." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Licensing Opportunities in Mwali"
                        blocks={[
                            {
                                items: [
                                    { title: "Banking Licenses", text: "Operate international and private banking services with MISA Banking Licenses, recognized by global service providers." },
                                    { title: "Brokerage & Forex Licenses", text: "Offer forex, CFD, and investment dealer services with flexible capital requirements." },
                                    { title: "Gaming & iGaming Licenses", text: "Launch casinos, sportsbooks, and iGaming platforms with a license respected by PSPs and affiliates." },
                                    { title: "Crypto & Virtual Asset Licenses", text: "Operate exchanges, wallets, and custody services under Comorian crypto-friendly frameworks." },
                                    { title: "Insurance & Trust Licenses", text: "Set up captive insurance, general reinsurance, and fiduciary/trust structures under MISA approval." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of Mwali Jurisdiction"
                        blocks={[
                            {
                                items: [
                                    { text: "Global Recognition — used by established offshore operators." },
                                    { text: "Regulatory Oversight — licenses are monitored by MISA." },
                                    { text: "Banking Access — higher PSP acceptance than newer jurisdictions (e.g., Anjouan, Western Sahara)." },
                                    { text: "Compliance-Friendly — aligns with FATF AML/CFT guidelines." },
                                    { text: "Multi-Sector Licensing — one jurisdiction for multiple business types." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Incorporation & Licensing Process"
                        blocks={[
                            {
                                items: [
                                    { text: "company-formation — incorporate an International Business Company (IBC) in Mwali." },
                                    { text: "Application Filing — prepare business plan, AML/KYC policies, supporting documents." },
                                    { text: "MISA Review & Approval — regulator evaluates and issues license." },
                                    { text: "Ongoing Compliance — annual filings, renewals, and AML updates." }
                                ]
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–10 weeks (license type dependent)",
                            },
                            {
                                name: "Setup Costs",
                                description: "From USD 20,000+ (depending on license)",
                            },
                            {
                                name: "Annual Renewals",
                                description: "Competitive compared to Seychelles, Belize, or Vanuatu",
                            },
                        ]}
                    />

                    <ComparisonTable
                        title="Mwali vs Other Jurisdictions"
                        columns={columns}
                        data={data}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory for Mwali?'
                        items={
                            [
                                { text: "Recognized MISA agent with licensing experience" },
                                { text: "End-to-end service — incorporation, licensing, compliance, banking" },
                                { text: "Access to liquidity providers, EMIs, and PSPs" },
                                { text: "Strong support for forex, crypto, and gaming operators" }
                            ]
                        }
                        />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for an established offshore jurisdiction?"
                        description="Mwali (Comoros) offers recognized, flexible, and compliance-ready licensing for banking, brokerage, gaming, and crypto."
                        buttonText="Book a Mwali Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const columns = [
    "feature",
    "Mwali (Comoros)",
    "Western Sahara (CRA)",
    "Curaçao",
    "Malta"
];

const data = [
    {
        feature: "Capital Requirement",
        "Mwali (Comoros)": "Flexible",
        "Western Sahara (CRA)": "❌ None",
        "Curaçao": "Low",
        "Malta": "High (€100k–750k)",
    },
    {
        feature: "Recognition",
        "Mwali (Comoros)": "High",
        "Western Sahara (CRA)": "Growing",
        "Curaçao": "Established",
        "Malta": "EU-Tier 1",
    },
    {
        feature: "License Types",
        "Mwali (Comoros)": "Banking, Brokerage, Gaming, Crypto, Insurance",
        "Western Sahara (CRA)": "Gaming, Brokerage, Crypto, Banking",
        "Curaçao": "Mainly Gaming",
        "Malta": "Gaming, Brokerage, Banking",
    },
    {
        feature: "Setup Time",
        "Mwali (Comoros)": "2–3 weeks",
        "Western Sahara (CRA)": "1–2 weeks",
        "Curaçao": "8–12 weeks",
        "Malta": "6–12 months",
    },
    {
        feature: "Cost",
        "Mwali (Comoros)": "Moderate",
        "Western Sahara (CRA)": "Low",
        "Curaçao": "Moderate",
        "Malta": "High",
    },
];


const faqData = [
    {
        question: "Is Mwali recognized internationally?",
        answer: "Yes — MISA licenses are globally recognized and accepted by PSPs and banks.",
    },
    {
        question: "How does it compare to Western Sahara?",
        answer: "Mwali is more established, but has higher capital and costs compared to Western Sahara’s no-capital CRA regime.",
    },
    {
        question: "Can I run a crypto exchange under Mwali?",
        answer: "Yes — crypto exchange and custody services are supported.",
    },
    {
        question: "What is the setup time?",
        answer: "6–10 weeks, depending on license type and documentation.",
    },
    {
        question: "What are the ongoing obligations?",
        answer: "Annual renewals, AML/KYC compliance, and regulator reporting.",
    },
];

const testimonialsData = [
    {
        quote: "We obtained a forex license in Mwali with Offshore Advisory. Excellent support and PSP introductions.",
        author: "James L.",
        role: "FX Broker CEO"
    },
    {
        quote: "Our iGaming platform licensed under Mwali was accepted by major PSPs. Offshore Advisory guided us every step.",
        author: "Maria K.",
        role: "Casino Operator"
    }
];
